module.exports = __webpack_public_path__ + "static/media/docIcon.4f81ff2a.svg";